export enum TaxPreparationAnswer {
  YES = "Ja",
  NO = "Nein",
  ANSWER_LATER = "Später beantw...",
  NEXT = "Weiter",
  EMPTY = "-",
}
